// Cell registry — name → React component mapping. The Officer
// notebook iterates `CELLS` from lib/cell-registry.ts to build the
// tab strip, then asks here for the active cell's component.
//
// Adding a cell: add the metagraph entry → add a component here →
// add the registry entry. Phase 6+ codegen replaces this manual mirror.
//
// Stub cells (02, 04, 05, 07, 08, 09, 10, 11) archived to
// _deleteme/code/apps-web/ — Officer.tsx shows "Unknown cell" for them.

import type { ComponentType } from 'react';
import { DashboardCell } from './00-Dashboard';
import { PendingReviewsCell } from './01-PendingReviews';
import { FilingsCalendarCell } from './03-FilingsCalendar';
import { IncidentsCell } from './06-Incidents';

// Cells either take an officerId (queue-bound) or no props
// (skeleton-only). The route owns the officerId and passes it
// through; cells that don't need it ignore the prop.
export type CellComponent = ComponentType<{ officerId: string }>;

export const CELL_COMPONENTS: Record<string, CellComponent> = {
  dashboard: DashboardCell,
  'pending-reviews': PendingReviewsCell,
  'filings-calendar': FilingsCalendarCell as CellComponent,
  incidents: IncidentsCell,
};
